import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n.js';
import './css/styles.css';
import './css/pages.css'; // Add this line
import { registerSW } from 'virtual:pwa-register';

// Register service worker
const updateSW = registerSW({
  onNeedRefresh() {
    // Show a prompt to the user to reload for new content
    if (confirm('New content available. Reload?')) {
      updateSW(true);
    }
  },
  onOfflineReady() {
    console.log('App ready to work offline');
    // Optionally show a notification to the user
  }
});

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);